<template>
  <div class="response_table">
    <table>
      <thead style="flex:0;">
        <tr>
          <th scope="col"> {{ translate("config.ts_create") }} </th>
          <th scope="col"> {{ translate("config.config_version") }} </th>
          <th scope="col"> {{ translate("config.group") }} </th>
          <th scope="col"> {{ translate("config.username") }} </th>
          <th v-if="config_history.length > 10" class="empty"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(config, config_key) in config_history" :key="config_key" class="config">
          <td :data-label="translate('config.ts_create')">
            {{ get_date(config.ts_create) }}
          </td>
          <td :data-label="translate('config.config_version')">
            {{ config.config_version }}
          </td>
          <td :data-label="translate('config.group')">
            <router-link :to="'/device_groups?group_id=' + config.group_id">
              {{ config.group_name }}
            </router-link>
          </td>
          <td :data-label="translate('config.username')">
            {{ config.username }}
          </td>
        </tr>
      </tbody>
    </table>

<!--    <div class="config_profile">-->
<!--      <TextTable-->
<!--          :all_data = "config_profile"-->
<!--          @update="load_conf"-->
<!--      />-->
<!--    </div>-->

    <div class="spinner">
      <scale-loader />
    </div>

  </div>
</template>

<script>

import ShowConfig from "../HistoryConfigChanges/Modal/ShowConfig.vue";
import CompareConfigsByVer from "../CompareConfigsByVer.vue";

export default {
  name: 'HistoryGroupConfig',
  props: {
    all_data: [Array, Object],
    last_version: [Number, String],
    dev_id: [Number],
    dev_fid: [Number, String]
  },
  data () {
    return {
      config_history: {}
    }
  },

  computed: {

  },
  watch: {

  },
  created () {
    this.config_history = JSON.parse(JSON.stringify(this.all_data))
  },
  methods: {
    compare_config(old_version){
      let list_config_ver = this.config_history.map((arr) =>{
        return {id: arr.ver , label: arr.ver }
      }).filter((item, index, self) =>
          index === self.findIndex((t) => JSON.stringify(t) === JSON.stringify(item))
      );

      let t = this.$createElement(CompareConfigsByVer, {
        props: {
          old_version: old_version,
          new_version: this.last_version,
          dev_id: this.dev_id,
          list_config_ver
        },
        on: {close: () => {this.$modal.hide('compare_configs_modal') }}
      })
      let temp = { render () { return t } }
      this.$modal.show(
          temp,
          {},
          {
            height: 'auto',
            width: 800,
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'compare_configs_modal'
          }
      )
    },
    show_config(version){
      var t = this.$createElement(ShowConfig, {
        props: {
          version: version
        },
        on: {
          update: () => {
            this.$emit('update')
            this.$modal.hide('show_config_modal')
          },
          close: () => {
            this.$modal.hide('show_config_modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(
          temp,
          {},
          {
            height: 'auto',
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'show_config_modal'
          }
      )
    },
  }
}

</script>

<style lang='scss' scoped>
  .response_table{
    padding: 0;
    label{
      font-size: 14px;
    }

    .empty{
      width: 10px;
    }

    .config{
      &:hover{
        background-color: #eaeaea;
      }
    }

    .actions{
      span{
        font-size: 18px;
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
        &:hover{
          color: #68B3C8;
          cursor: pointer;
        }
      }
    }

    tbody{
      &::-webkit-scrollbar{
        width: 10px;
      }
    }
  }
</style>
